// import { gsap } from 'gsap';
// iimport { ScrollTrigger } from 'gsap/ScrollTrigger';
// iimport { CustomEase } from "gsap/CustomEase";
import Swiper from 'swiper/bundle';
import Lenis from '@studio-freight/lenis';
// import Swup from 'swup';
// import SwupDebugPlugin from '@swup/debug-plugin';
// iimport Lottie from 'lottie-web';

/*-------------------------------------
 Lenis設定（スムーススクロール）
--------------------------------------*/
const lenis = new Lenis();
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);


/*-------------------------------------
 スクロール時の処理
--------------------------------------*/
let startPos = 0;
let winScrollTop = 0;
let threshold = window.innerHeight * 0.5;
window.addEventListener('scroll', () => {
  winScrollTop = window.scrollY;

  if (winScrollTop !== 0) {
    document.body.classList.add('is-scroll');
  } else {
    document.body.classList.remove('is-scroll');
  }

  if (winScrollTop >= startPos) {
    if (winScrollTop >= threshold) {
      document.body.classList.add('is-down');
    }
  } else {
    document.body.classList.remove('is-down');
  }
  startPos = winScrollTop;
});
window.addEventListener('resize', () => {
  threshold = window.innerHeight;
});

/*-------------------------------------
 GSAP ScrollTrigger
--------------------------------------*/

/*
gsap.registerPlugin(ScrollTrigger);

function createScrollTrigger(selector, start, className, markers = false, pin = false) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((el, index) => {
    ScrollTrigger.create({
      trigger: el,
      id: index + 1,
      start: start,
      toggleClass: { targets: el, className: className },
      once: true,
      markers: markers,
			pin: pin,
    });
  });
}
  */

/*-------------------------------------
 サイト内検索
--------------------------------------*/
const SEARCH_INDEX_URL = '/data/search-index.json';
const SEARCH_RESULTS_PER_PAGE = 50;
const SEARCH_PAGINATION_WINDOW = 5;
const SITE_SEARCH_DEBUG = true;

function debugSearch(...args) {
  if (SITE_SEARCH_DEBUG) {
    console.log('[SiteSearch]', ...args);
  }
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function formatPrice(value) {
  if (value == null || String(value).trim() === '') {
    return '-';
  }
  return Number(value).toLocaleString('ja-JP');
}

function getSearchQuery() {
  return new URLSearchParams(window.location.search).get('q')?.trim() ?? '';
}

function getSearchPage() {
  const page = Number(new URLSearchParams(window.location.search).get('p'));
  return Number.isFinite(page) && page > 0 ? Math.floor(page) : 1;
}

function buildSearchResultUrl(query, page = 1) {
  const params = new URLSearchParams();
  params.set('q', query);
  if (page > 1) params.set('p', String(page));
  return `${window.location.pathname}?${params.toString()}`;
}

function getPaginationRange(currentPage, totalPages, windowSize) {
  if (totalPages <= windowSize) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  let start = Math.max(1, currentPage - Math.floor(windowSize / 2));
  let end = start + windowSize - 1;

  if (end > totalPages) {
    end = totalPages;
    start = end - windowSize + 1;
  }

  return Array.from({ length: end - start + 1 }, (_, index) => start + index);
}

function renderPagination(container, { currentPage, totalPages, buildPageUrl, windowSize = SEARCH_PAGINATION_WINDOW }) {
  const list = container.querySelector('ul');
  if (!list) return;

  list.replaceChildren();

  if (totalPages <= 1) return;

  const fragment = document.createDocumentFragment();

  if (currentPage > 1) {
    const prevItem = document.createElement('li');
    const prevLink = document.createElement('a');
    prevLink.href = buildPageUrl(currentPage - 1);
    prevLink.className = 'pPagination arrow prev';
    prevLink.innerHTML = '<img src="/images/icon_arrow_m.svg" alt="">';
    prevItem.appendChild(prevLink);
    fragment.appendChild(prevItem);
  }

  getPaginationRange(currentPage, totalPages, windowSize).forEach((page) => {
    const pageItem = document.createElement('li');

    if (page === currentPage) {
      const current = document.createElement('span');
      current.className = 'pPagination is-active';
      current.textContent = String(page);
      pageItem.appendChild(current);
    } else {
      const pageLink = document.createElement('a');
      pageLink.href = buildPageUrl(page);
      pageLink.className = 'pPagination';
      pageLink.textContent = String(page);
      pageItem.appendChild(pageLink);
    }

    fragment.appendChild(pageItem);
  });

  if (currentPage < totalPages) {
    const nextItem = document.createElement('li');
    const nextLink = document.createElement('a');
    nextLink.href = buildPageUrl(currentPage + 1);
    nextLink.className = 'pPagination arrow next';
    nextLink.innerHTML = '<img src="/images/icon_arrow_m.svg" alt="">';
    nextItem.appendChild(nextLink);
    fragment.appendChild(nextItem);
  }

  list.appendChild(fragment);
}

function filterSearchItems(items, query) {
  const terms = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (!terms.length) return [];

  return items.filter((item) => {
    const text = item.searchText.toLowerCase();
    return terms.every((term) => text.includes(term));
  });
}

const PRODUCT_IMAGE_PLACEHOLDER = '/images/placeholder.webp';

function getProductImageSrc(url) {
  const trimmed = url?.trim();
  return trimmed || PRODUCT_IMAGE_PLACEHOLDER;
}

function createProductUnit(item) {
  const unit = document.createElement('div');
  unit.className = 'unit';

  const imageUrl = getProductImageSrc(item.image?.url);
  const imageClass = imageUrl === PRODUCT_IMAGE_PLACEHOLDER ? 'pImage default' : 'pImage';

  const badge = item.flags.partialStoreOnly
    ? '<div class="pBadge">一部店舗のみ対応</div>'
    : '';

  unit.innerHTML = `
    <img src="${escapeHtml(imageUrl)}" alt="" class="${imageClass}" loading="lazy">
    <div class="pPriceLabelRow">
      <p class="pPriceLabel">${escapeHtml(item.manufacturer.name)}</p>
      <p class="pPriceLabel">${escapeHtml(item.categoryPrimary.name)}</p>
      <p class="pPriceLabel">${escapeHtml(item.productNumber)}</p>
    </div>
    <div class="pPriceRow">
      <div class="row">
        <div class="pCondition">新品</div>
        <div class="pPrice">${formatPrice(item.prices.new)}<span>円</span></div>
      </div>
      <div class="row">
        <div class="pCondition">中古上限</div>
        <div class="pPrice">${formatPrice(item.prices.used)}<span>円</span></div>
      </div>
    </div>
    ${badge}
  `;

  return unit;
}

function renderProductUnits(container, items) {
  container.replaceChildren();
  items.forEach((item) => {
    container.appendChild(createProductUnit(item));
  });
}

function initSiteSearch() {
  const form = document.getElementById('searchForm');
  const input = document.getElementById('searchInput');
  debugSearch('initSiteSearch', {
    form: !!form,
    input: !!input,
    action: form?.getAttribute('action') ?? null,
  });
  if (!form || !input) return;

  form.addEventListener('submit', (event) => {
    const value = input.value.trim();
    debugSearch('form submit', { value, willPreventDefault: !value });
    if (!value) {
      event.preventDefault();
      input.focus();
    }
  });
}

function initAggressiveSection(root = document.getElementById('aggressive')) {
  if (!root || root.hidden) return;

  const VISIBLE_UNIT_COUNT = 4;
  const BUTTON_THRESHOLD = 5;
  const units = root.querySelectorAll('.component.type_price .inner > .unit');
  const button = root.querySelector('.button');

  if (!units.length) {
    root.hidden = true;
    return;
  }

  const showButton = units.length >= BUTTON_THRESHOLD;
  if (button) {
    button.hidden = !showButton;
    button.classList.remove('is-active');
    const toggleButton = button.querySelector('.pButton');
    if (toggleButton) toggleButton.textContent = 'さらに見る';
  }

  units.forEach((unit, index) => {
    unit.classList.toggle('is-hidden', showButton && index >= VISIBLE_UNIT_COUNT);
  });

  if (!button || !showButton || button.dataset.aggressiveInitialized) return;

  button.dataset.aggressiveInitialized = 'true';
  const toggleButton = button.querySelector('.pButton');
  const labelMore = 'さらに見る';
  const labelClose = 'とじる';

  button.addEventListener('click', () => {
    const currentUnits = root.querySelectorAll('.component.type_price .inner > .unit');
    const isExpanded = !button.classList.contains('is-active');

    currentUnits.forEach((unit, index) => {
      if (index >= VISIBLE_UNIT_COUNT) {
        unit.classList.toggle('is-hidden', !isExpanded);
      }
    });

    button.classList.toggle('is-active', isExpanded);
    if (toggleButton) {
      toggleButton.textContent = isExpanded ? labelClose : labelMore;
    }
  });
}

async function initSearchResultPage() {
  debugSearch('initSearchResultPage start', {
    pathname: window.location.pathname,
    search: window.location.search,
  });

  const page = document.querySelector('[data-search-result]');
  if (!page) {
    debugSearch('abort: [data-search-result] not found on page');
    return;
  }

  const query = getSearchQuery();
  debugSearch('query resolved', { query });
  const title = document.getElementById('searchResultTitle');
  const summarySection = document.getElementById('searchResultSummary');
  const summaryMessage = document.getElementById('searchResultMessage');
  const noResultsAction = document.getElementById('searchResultNoResultsAction');
  const resultSection = document.getElementById('searchResultSection');
  const resultHeading = document.getElementById('searchResultHeading');
  const aggressiveBlock = document.getElementById('aggressive');
  const aggressiveInner = document.getElementById('searchResultAggressive');
  const resultList = document.getElementById('searchResultList');
  const pagination = document.getElementById('searchResultPagination');
  const searchInput = document.getElementById('searchInput');
  const breadcrumbCurrent = document.getElementById('searchResultBreadcrumb');
  const titleText = query ? `${query}の検索結果` : '検索結果';

  debugSearch('DOM elements', {
    title: !!title,
    summarySection: !!summarySection,
    summaryMessage: !!summaryMessage,
    resultSection: !!resultSection,
    resultHeading: !!resultHeading,
    aggressiveBlock: !!aggressiveBlock,
    aggressiveInner: !!aggressiveInner,
    resultList: !!resultList,
    pagination: !!pagination,
    searchInput: !!searchInput,
    breadcrumbCurrent: !!breadcrumbCurrent,
  });

  if (searchInput) searchInput.value = query;
  if (title) title.textContent = titleText;
  if (breadcrumbCurrent) breadcrumbCurrent.textContent = titleText;

  const showSummary = (message, { showBackButton = false } = {}) => {
    if (summaryMessage) summaryMessage.textContent = message;
    setElementVisible(summarySection, true);
    setElementVisible(noResultsAction, showBackButton);
  };

  const setElementVisible = (element, visible) => {
    if (!element) return;
    element.hidden = !visible;
    element.classList.toggle('is-hidden', !visible);
  };

  const hideSearchResults = () => {
    setElementVisible(resultHeading, false);
    setElementVisible(resultSection, false);
    setElementVisible(pagination, false);
    setElementVisible(aggressiveBlock, false);
    setElementVisible(noResultsAction, false);
  };

  hideSearchResults();

  if (!query) {
    debugSearch('abort: empty query');
    showSummary('検索結果がありません。', { showBackButton: true });
    return;
  }

  try {
    debugSearch('fetch start', { url: SEARCH_INDEX_URL });
    const response = await fetch(SEARCH_INDEX_URL);
    debugSearch('fetch response', {
      ok: response.ok,
      status: response.status,
      statusText: response.statusText,
      contentType: response.headers.get('content-type'),
    });
    if (!response.ok) throw new Error(`Failed to fetch search index (${response.status})`);

    const data = await response.json();
    debugSearch('index loaded', {
      hasItems: Array.isArray(data?.items),
      itemCount: data?.items?.length ?? 0,
      sampleKeys: data?.items?.[0] ? Object.keys(data.items[0]) : [],
    });

    if (!Array.isArray(data?.items)) {
      throw new Error('search index has no items array');
    }

    const results = filterSearchItems(data.items, query);
    const aggressiveItems = results.filter((item) => item.flags.aggressive);
    const listResults = results.filter((item) => !item.flags.aggressive);
    debugSearch('filter done', {
      query,
      resultCount: results.length,
      listResultCount: listResults.length,
      aggressiveCount: aggressiveItems.length,
      firstResult: results[0]?.productNumber ?? null,
    });

    if (!results.length) {
      debugSearch('no matching results');
      hideSearchResults();
      showSummary('検索結果がありません。', { showBackButton: true });
      return;
    }

    if (!resultList) {
      debugSearch('abort: #searchResultList not found');
      hideSearchResults();
      showSummary('検索結果の表示領域が見つかりません');
      return;
    }

    setElementVisible(summarySection, false);
    setElementVisible(noResultsAction, false);
    setElementVisible(resultHeading, true);
    setElementVisible(resultSection, true);

    const totalPages = Math.ceil(listResults.length / SEARCH_RESULTS_PER_PAGE)
      || (aggressiveItems.length ? 1 : 0);
    const currentPage = Math.min(Math.max(getSearchPage(), 1), totalPages);
    const startIndex = (currentPage - 1) * SEARCH_RESULTS_PER_PAGE;
    const pageResults = listResults.slice(startIndex, startIndex + SEARCH_RESULTS_PER_PAGE);

    renderProductUnits(resultList, pageResults);
    debugSearch('results rendered', {
      containerId: resultList.id,
      count: pageResults.length,
      currentPage,
      totalPages,
      aggressiveCount: aggressiveItems.length,
    });

    if (pagination && totalPages > 1) {
      renderPagination(pagination, {
        currentPage,
        totalPages,
        buildPageUrl: (page) => buildSearchResultUrl(query, page),
      });
      setElementVisible(pagination, true);
    }

    if (currentPage === 1 && aggressiveItems.length && aggressiveInner) {
      renderProductUnits(aggressiveInner, aggressiveItems);
      setElementVisible(aggressiveBlock, true);
      initAggressiveSection(aggressiveBlock);
      debugSearch('aggressive items rendered', { count: aggressiveItems.length });
    } else {
      debugSearch('aggressive section skipped', {
        currentPage,
        aggressiveCount: aggressiveItems.length,
        hasAggressiveInner: !!aggressiveInner,
      });
    }
  } catch (error) {
    console.error('[SiteSearch] error', error);
    debugSearch('fetch/render failed', {
      message: error?.message,
      stack: error?.stack,
    });
    hideSearchResults();
    showSummary('検索データの取得に失敗しました');
  }
}

/*-------------------------------------
 お役立ちコラム検索
--------------------------------------*/
const NEWS_SEARCH_INDEX_URL = '/news/search-index.json';
const NEWS_SEARCH_RESULTS_PER_PAGE = 6;

function fixLooseJsonText(raw) {
  let text = raw.replace(/\}\s*\n\s*\}\s*$/, '}\n  ]\n}');

  let out = '';
  let inString = false;
  let escaped = false;

  for (let i = 0; i < text.length; i++) {
    const ch = text[i];

    if (escaped) {
      out += ch;
      escaped = false;
      continue;
    }

    if (ch === '\\' && inString) {
      out += ch;
      escaped = true;
      continue;
    }

    if (ch === '"') {
      inString = !inString;
      out += ch;
      continue;
    }

    if (inString && ch === '\n') {
      out += '\\n';
      continue;
    }

    if (inString && ch === '\r') {
      if (text[i + 1] === '\n') i++;
      out += '\\n';
      continue;
    }

    if (inString && ch === '\t') {
      out += '\\t';
      continue;
    }

    out += ch;
  }

  return out;
}

async function fetchNewsSearchIndex(url = NEWS_SEARCH_INDEX_URL) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch news search index (${response.status})`);
  }

  const raw = await response.text();
  return JSON.parse(fixLooseJsonText(raw));
}

function getNewsSearchQuery() {
  return new URLSearchParams(window.location.search).get('s')?.trim() ?? '';
}

function buildNewsSearchResultUrl(query, page = 1) {
  const params = new URLSearchParams();
  params.set('s', query);
  params.set('post_type', 'news');
  if (page > 1) params.set('p', String(page));
  return `${window.location.pathname}?${params.toString()}`;
}

function getNewsSearchText(item) {
  if (item.searchText) return item.searchText;
  return [item.title, item.categories, item.excerpt, item.content]
    .filter(Boolean)
    .join(' ');
}

function filterNewsSearchItems(items, query) {
  const terms = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (!terms.length) return [];

  return items.filter((item) => {
    const text = getNewsSearchText(item).toLowerCase();
    return terms.every((term) => text.includes(term));
  });
}

function createNewsCategoryList(categories) {
  const list = document.createElement('ul');
  list.className = 'post__cat';

  String(categories || '')
    .split(',')
    .map((category) => category.trim())
    .filter(Boolean)
    .forEach((category) => {
      const li = document.createElement('li');
      li.className = 'c-category';
      li.textContent = category;
      list.appendChild(li);
    });

  return list;
}

function createNewsArticle(item) {
  const article = document.createElement('article');
  article.className = 'secNewsList__post';

  const link = document.createElement('a');
  link.href = item.url;

  const head = document.createElement('div');
  head.className = 'post__head';

  const meta = document.createElement('div');
  meta.className = 'post__meta';
  meta.appendChild(createNewsCategoryList(item.categories));

  const published = document.createElement('p');
  published.className = 'c-item__date en';
  published.innerHTML = `投稿日：<time>${escapeHtml(item.publishedAt)}</time>`;
  meta.appendChild(published);

  const divider = document.createElement('span');
  divider.className = 'spnone';
  divider.textContent = '｜';
  meta.appendChild(divider);

  const modified = document.createElement('p');
  modified.className = 'c-item__date en';
  modified.innerHTML = `更新日：<time>${escapeHtml(item.modifiedAt)}</time>`;
  meta.appendChild(modified);

  const title = document.createElement('h2');
  title.className = 'post__title';
  title.textContent = item.title;

  head.appendChild(meta);
  head.appendChild(title);

  const content = document.createElement('div');
  content.className = 'post__cont flex nowrap';

  const imageWrap = document.createElement('div');
  imageWrap.className = 'post__img img';
  imageWrap.innerHTML = `
    <img width="820" height="562" src="${escapeHtml(item.thumbnail)}" class="img wp-post-image" alt="${escapeHtml(item.title)}" decoding="async" loading="lazy">
    <figure></figure>
  `;

  const textWrap = document.createElement('div');
  textWrap.className = 'post__txt hira';
  textWrap.innerHTML = `
    <div class="post__excerpt">
      <p>${escapeHtml(item.excerpt)}</p>
    </div>
    <div class="btn-02">
      <span class="a pButton">つづきを見る</span>
    </div>
  `;

  content.appendChild(imageWrap);
  content.appendChild(textWrap);
  link.appendChild(head);
  link.appendChild(content);
  article.appendChild(link);

  return article;
}

function renderNewsArticles(container, items) {
  container.replaceChildren();
  items.forEach((item) => {
    container.appendChild(createNewsArticle(item));
  });
}

function initNewsSearchForm() {
  const form = document.getElementById('search-newspost');
  if (!form) return;

  const input = form.querySelector('input[name="s"]');
  if (!form.getAttribute('action')) {
    form.setAttribute('action', '/news/result.html');
  }

  form.addEventListener('submit', (event) => {
    const value = input?.value.trim() ?? '';
    if (!value) {
      event.preventDefault();
      input?.focus();
    }
  });
}

async function initNewsSearchResultPage() {
  const page = document.querySelector('[data-news-search-result]');
  if (!page) return;

  const query = getNewsSearchQuery();
  const summarySection = document.getElementById('newsSearchResultSummary');
  const summaryMessage = document.getElementById('newsSearchResultMessage');
  const noResultsAction = document.getElementById('newsSearchResultNoResultsAction');
  const resultList = document.getElementById('newsSearchResultList');
  const pagination = document.getElementById('newsSearchResultPagination');
  const searchInput = document.querySelector('#search-newspost input[name="s"]');
  const breadcrumbCurrent = document.getElementById('newsSearchResultBreadcrumb');
  const titleText = query ? `${query}の検索結果` : '検索結果';

  if (searchInput) searchInput.value = query;
  if (breadcrumbCurrent) breadcrumbCurrent.textContent = titleText;

  const setElementVisible = (element, visible) => {
    if (!element) return;
    element.hidden = !visible;
    element.classList.toggle('is-hidden', !visible);
  };

  const showSummary = (message, { showBackButton = false } = {}) => {
    if (summaryMessage) summaryMessage.textContent = message;
    setElementVisible(summarySection, true);
    setElementVisible(noResultsAction, showBackButton);
  };

  const hideSearchResults = () => {
    setElementVisible(resultList, false);
    setElementVisible(pagination, false);
    setElementVisible(noResultsAction, false);
  };

  hideSearchResults();

  if (!query) {
    showSummary('検索結果がありません。', { showBackButton: true });
    return;
  }

  try {
    const data = await fetchNewsSearchIndex();
    if (!Array.isArray(data?.items)) {
      throw new Error('news search index has no items array');
    }

    const results = filterNewsSearchItems(data.items, query);

    if (!results.length) {
      hideSearchResults();
      showSummary('検索結果がありません。', { showBackButton: true });
      return;
    }

    if (!resultList) {
      hideSearchResults();
      showSummary('検索結果の表示領域が見つかりません');
      return;
    }

    showSummary(titleText);
    setElementVisible(resultList, true);

    const totalPages = Math.ceil(results.length / NEWS_SEARCH_RESULTS_PER_PAGE);
    const currentPage = Math.min(Math.max(getSearchPage(), 1), totalPages);
    const startIndex = (currentPage - 1) * NEWS_SEARCH_RESULTS_PER_PAGE;
    const pageResults = results.slice(startIndex, startIndex + NEWS_SEARCH_RESULTS_PER_PAGE);

    renderNewsArticles(resultList, pageResults);

    if (pagination && totalPages > 1) {
      renderPagination(pagination, {
        currentPage,
        totalPages,
        buildPageUrl: (page) => buildNewsSearchResultUrl(query, page),
      });
      setElementVisible(pagination, true);
    }
  } catch (error) {
    console.error('[NewsSearch] error', error);
    hideSearchResults();
    showSummary('検索データの取得に失敗しました');
  }
}

/*-------------------------------------
 記事目次（ez-toc 互換）自動生成
--------------------------------------*/
function getHeadingText(heading) {
  const clone = heading.cloneNode(true);
  clone.querySelectorAll('.ez-toc-section, .ez-toc-section-end').forEach((el) => el.remove());
  return clone.textContent.trim();
}

function slugifyHeading(text) {
  const encoded = encodeURIComponent(text.trim());
  return encoded || 'section';
}

function getHeadingId(heading, usedIds) {
  const ezSection = heading.querySelector('.ez-toc-section[id]');
  let id = ezSection?.id || heading.id;

  if (!id) {
    id = slugifyHeading(getHeadingText(heading));
  }

  let uniqueId = id;
  let count = 2;
  while (usedIds.has(uniqueId)) {
    uniqueId = `${id}-${count++}`;
  }
  usedIds.add(uniqueId);

  heading.querySelectorAll('.ez-toc-section, .ez-toc-section-end').forEach((el) => el.remove());
  heading.id = uniqueId;

  return uniqueId;
}

function createTocLink(id, text, level, index) {
  const li = document.createElement('li');
  li.className = `ez-toc-page-1 ez-toc-heading-level-${level}`;

  const a = document.createElement('a');
  a.className = `ez-toc-link ez-toc-heading-${index}`;
  a.href = `#${id}`;
  a.textContent = text;

  li.appendChild(a);
  return li;
}

function initEzToc() {
  const content = document.getElementById('pryc-wp-acctp-original-content');
  const tocContainer = document.getElementById('ez-toc-container');
  if (!content || !tocContainer) return;

  const headings = content.querySelectorAll('h2, h3, h4');
  if (!headings.length) {
    tocContainer.hidden = true;
    return;
  }

  const rootList = tocContainer.querySelector('nav ul.ez-toc-list-level-1');
  if (!rootList) return;

  rootList.replaceChildren();

  const usedIds = new Set();
  const stack = [{ level: 1, list: rootList }];
  let linkIndex = 1;

  headings.forEach((heading) => {
    const level = Number(heading.tagName.charAt(1));
    const text = getHeadingText(heading);
    if (!text) return;

    const id = getHeadingId(heading, usedIds);
    const li = createTocLink(id, text, level, linkIndex++);

    while (stack.length > 1 && stack[stack.length - 1].level >= level) {
      stack.pop();
    }

    stack[stack.length - 1].list.appendChild(li);

    const childList = document.createElement('ul');
    childList.className = `ez-toc-list-level-${level + 1}`;
    li.appendChild(childList);
    stack.push({ level, list: childList });
  });

  rootList.querySelectorAll('li').forEach((li) => {
    const childUl = li.querySelector(':scope > ul');
    if (childUl && !childUl.children.length) {
      childUl.remove();
    }
  });
}

/*-------------------------------------
 メニュー開閉・トグル関連
--------------------------------------*/
document.addEventListener('DOMContentLoaded', async () => {
  // createScrollTrigger('.fadeUp','top 75%','is-active');
  document.body.classList.add('is-ready');
  initSiteSearch();
  await initSearchResultPage();
  initNewsSearchForm();
  await initNewsSearchResultPage();
  initEzToc();

  /*
  const menuButton = document.getElementById('menuButton');
  const gnav = document.getElementById('gnav');
  let isMenuOpen = false;
  let scrollPos = 0;

  menuButton.addEventListener('click', () => {
    menuButton.classList.toggle('show');
    gnav.classList.toggle('show');
    if (!isMenuOpen) {
      scrollPos = window.scrollY;
      document.body.classList.add('fixed');
      document.body.style.top = `-${scrollPos}px`;
      isMenuOpen = true;
    } else {
      closeMenu();
    }
  });

  function closeMenu() {
    menuButton.classList.remove('show');
    gnav.classList.remove('show');
    document.body.classList.remove('fixed');
    document.body.style.top = '0';
    window.scrollTo(0, scrollPos);
    isMenuOpen = false;
  }

  Array.from(gnav.querySelectorAll('a')).forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  // メニュー以外をクリックしたら閉じる
  document.addEventListener('click', (e) => {
    if (!gnav.contains(e.target) && !menuButton.contains(e.target) && isMenuOpen) {
      closeMenu();
    }
  });

  // リサイズ対応
  function handleResize() {
    if (window.innerWidth >= 768) {
      document.body.classList.remove('fixed');
      document.body.style.top = '0';
    }
  }
  window.addEventListener('load', handleResize);
  window.addEventListener('resize', handleResize);

  */

  /*-------------------------------------
   ページトップボタン
  --------------------------------------*/
  const pagetopA = document.getElementById('pagetopA');
  const pagetopB = document.getElementById('pagetopB');
  if (pagetopA && pagetopB) {
    pagetopA.addEventListener('click', () => {
      lenis.scrollTo(0);
    });
    pagetopB.addEventListener('click', () => {
      lenis.scrollTo(0);
    });
    window.addEventListener('scroll', (e) => {
      const scrollTop = window.pageYOffset;
      const footer = document.querySelector('footer');
      
      // スクロールが20pxを超えたらis-scrollクラスを追加
      if (scrollTop >= 20) {
        pagetopA.classList.add('is-scroll');
      } else {
        pagetopA.classList.remove('is-scroll');
      }
      
      // pagetopBが画面内に現れたらis-bottomクラスを追加
      if (pagetopB) {
        const pagetopBRect = pagetopB.getBoundingClientRect();
        const isPagetopBVisible = pagetopBRect.top <= window.innerHeight;
        
        if (isPagetopBVisible) {
          pagetopA.classList.add('is-bottom');
        } else {
          pagetopA.classList.remove('is-bottom');
        }
      }
    });
  }

  const anchorTarget = document.querySelector('.type_anchor .inner');
  if (anchorTarget) {
    const titles = document.querySelectorAll('.anchor');
    let anchorText = '';
    
    titles.forEach(title => {
      const id = title.getAttribute('id');
      const text = title.nextElementSibling.textContent;
      anchorText += `<li><a href="#${id}">${text}</a></li>`;
    });
    anchorTarget.innerHTML = `<ul>${anchorText}</ul>`;
    
  }

  const articleWrapper = document.querySelector('.article-wrapper');
  
  if (articleWrapper) {
    const articleContents = document.querySelector('.article-contents');
    const navAnchors = document.querySelector('.article-nav .anchors');
    
    if (articleContents && navAnchors) {
      const anchors = articleContents.querySelectorAll('a.anchor');
      let anchorLinks = '';
      console.log(anchors);
      
      anchors.forEach(anchor => {
        const id = anchor.getAttribute('id');
        const text = anchor.getAttribute('data-title');
        console.log(id, text);
        if (!text) return;
        anchorLinks += `<li><a href="#${id}" class="pArticleNav">${text}</a></li>`;
      });
      navAnchors.innerHTML = `${anchorLinks}`;
    }
  }

  // まずセレクタにマッチする要素が存在するか確認
  const anchors = document.querySelectorAll('a[href^="#"], a[href^="/#"], .anchors a');

  anchors.forEach(anchor => {
    
    anchor.addEventListener('click', function(event) {
      console.log('Anchor clicked:', this.getAttribute('href'));
      
      const href = this.getAttribute('href');
      if (!href || href.startsWith('mailto:') || !href.includes('#')) return;
      
      const targetId = href.includes('#') ? href.split('#')[1] : null;
      if (!targetId) return;
      
      const targetElement = document.getElementById(targetId);
      console.log('Target element:', targetId, targetElement);
      
      if (targetElement) {
        event.preventDefault();
        const scrollBaseElement = targetId === 'kaitori_banner'
          ? targetElement
          : targetElement.nextElementSibling;
        if (scrollBaseElement) {
          const rectTop = scrollBaseElement.getBoundingClientRect().top + window.scrollY;
          const offset = targetId === 'kaitori_banner'
            ? 0
            : window.innerWidth < 768
              ? (80 / 390) * window.innerWidth
              : (120 / 1440) * Math.min(window.innerWidth, 1440);
          const targetPosition = rectTop - offset;
          console.log('.m_boxlistの上端位置:', rectTop);
          console.log('offset:', offset);
          console.log('スクロール先位置:', targetPosition);
          lenis.scrollTo(targetPosition);
        }
      }
    });
  });

  const faqElements = document.querySelectorAll('.type_faq');
  if (faqElements.length) {
    faqElements.forEach(faq => {
      const questions = faq.querySelectorAll('.pFaq');
      questions.forEach(question => {
        const q = question.querySelector('.q');
        question.addEventListener('click', () => {
          question.classList.toggle('is-active');
          const nextElement = q.nextElementSibling;
          if (nextElement.style.display === 'none' || !nextElement.style.display) {
            nextElement.style.display = 'block';
          } else {
            nextElement.style.display = 'none';
          }
        });
      });
    });
  }

  const areaElements = document.querySelectorAll('.type_area');
  if (areaElements.length) {
    areaElements.forEach(unit => {
      const units = unit.querySelectorAll('.unit');
      units.forEach(unit => {
        const area = unit.querySelector('.area');
        unit.addEventListener('click', () => {
          unit.classList.toggle('is-active');
          const nextElement = area.nextElementSibling;
          if (nextElement.style.display === 'none' || !nextElement.style.display) {
            nextElement.style.display = 'block';
          } else {
            nextElement.style.display = 'none';
          }
        });
      });
    });
  }
});



/*-------------------------------------
 フッター固定ボタンのスクロール処理
--------------------------------------*/
let fixedFooterStartPos = 0;
const fixedFooterButton = document.getElementById('fixedFooterButton');

window.addEventListener('scroll', () => {
  const winScrollTop = window.scrollY;
  const documentHeight = document.documentElement.scrollHeight;
  const footerHeight = document.querySelector('footer').offsetHeight;
  const windowHeight = window.innerHeight;
  
  if (fixedFooterButton) {
    if (winScrollTop > 500 && winScrollTop < documentHeight - footerHeight - windowHeight) {
      fixedFooterButton.classList.add('is-scroll');
    } else {
      fixedFooterButton.classList.remove('is-scroll');
    }
  }
  fixedFooterStartPos = winScrollTop;
});

/*-------------------------------------
 買取バナーのスクロール処理
--------------------------------------*/
let kaitoriBannerStartPos = 0;
const kaitoriBannerButton = document.getElementById('kaitoriBannerButton');
const priceSections = document.querySelectorAll('.component.type_price');
const lastPriceSection = priceSections.length ? priceSections[priceSections.length - 1] : null;
const kaitoriBanner = document.getElementById('kaitori_banner');

const isElementInViewport = (element, windowHeight) => {
  const rect = element.getBoundingClientRect();
  return rect.top < windowHeight && rect.bottom > 0;
};

const updateKaitoriBannerScroll = () => {
  if (!kaitoriBannerButton) return;

  const winScrollTop = window.scrollY;
  const documentHeight = document.documentElement.scrollHeight;
  const footer = document.querySelector('footer');
  const footerHeight = footer ? footer.offsetHeight : 0;
  const windowHeight = window.innerHeight;
  const isBeforeFooter = winScrollTop < documentHeight - footerHeight - windowHeight;

  const isLastPriceVisible = lastPriceSection
    ? isElementInViewport(lastPriceSection, windowHeight)
    : false;
  const isKaitoriBannerVisible = kaitoriBanner
    ? isElementInViewport(kaitoriBanner, windowHeight)
    : false;

  if (isLastPriceVisible && isBeforeFooter && !isKaitoriBannerVisible) {
    kaitoriBannerButton.classList.add('is-scroll');
  } else {
    kaitoriBannerButton.classList.remove('is-scroll');
  }
};

window.addEventListener('scroll', () => {
  updateKaitoriBannerScroll();
  kaitoriBannerStartPos = window.scrollY;
});

updateKaitoriBannerScroll();

/*
const tables = document.querySelectorAll('.table_set');
if (tables.length) {
  const handleTableOverflow = () => {
    tables.forEach(tableSet => {
      const existingOverflow = tableSet.querySelectorAll('.table_overflow');
      existingOverflow.forEach(overflow => overflow.remove());
      
      const tableSetWidth = tableSet.offsetWidth;
      const table = tableSet.querySelector('table');
      if (table) {
        const tableWidth = table.offsetWidth;
        console.log('tableWidth:', tableWidth);
        console.log('tableSetWidth:', tableSetWidth);
        if (tableWidth > tableSetWidth) {
          console.log('yes');
          const overflowDiv = document.createElement('div');
          overflowDiv.className = 'table_overflow';
          tableSet.insertBefore(overflowDiv, tableSet.firstChild);
        }
      }
    });
  };
  
  window.addEventListener('load', handleTableOverflow);
  window.addEventListener('resize', handleTableOverflow);
}
  */

const topSliderElement = document.querySelector('#topSlider .swiper');
const slideCount = topSliderElement ? topSliderElement.querySelectorAll('.swiper-slide').length : 0;

const topSlider = new Swiper('#topSlider .swiper', {
  loop: slideCount > 1,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  speed: 1000,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 'auto',
      centeredSlides: true,
    }
  },
});

const topColumnElement = document.querySelector('#topColumn .swiper');

const NEW_BADGE_DAYS = 30;

function getDaysSince(dateStr) {
  try {
    if (typeof Temporal !== 'undefined') {
      const published = Temporal.PlainDate.from(dateStr);
      return Temporal.Now.plainDateISO().since(published, { largestUnit: 'day' }).days;
    }

    const [year, month, day] = dateStr.split('-').map(Number);
    const published = new Date(year, month - 1, day);
    if (Number.isNaN(published.getTime())) return null;

    const today = new Date();
    published.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return Math.round((today.getTime() - published.getTime()) / 86400000);
  } catch {
    return null;
  }
}

document.querySelectorAll('#topColumn a[datetime]').forEach((link) => {
  const days = getDaysSince(link.getAttribute('datetime'));
  if (days !== null && days >= 0 && days <= NEW_BADGE_DAYS) {
    link.classList.add('is-new');
  }
});

const topColumnSlider = new Swiper('#topColumn .swiper', {
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  speed: 1000,
  slidesPerView: 'auto',
  centeredSlides: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

});


/*-------------------------------------
 SPメニューのサブメニュー表示
--------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const spMenuContents = document.getElementById('spMenuContents');
  const spMenuTitle = document.getElementById('spMenuTitle');
  const backSpMenu = document.getElementById('backSpMenu');
  const titleHeading = spMenuTitle?.querySelector('h2');
  
  if (spMenuContents && spMenuTitle && backSpMenu && titleHeading) {
    // 元のメニューコンテンツを保存
    const originalContents = spMenuContents.innerHTML;
    
    // サブメニューを開く処理
    document.querySelectorAll('.open-submenu').forEach(submenuBtn => {
      submenuBtn.addEventListener('click', () => {
        // クリックされたサブメニューのタイトルを取得
        const submenuTitle = submenuBtn.textContent;
        // 隣接するulを取得
        const submenuContent = submenuBtn.nextElementSibling;
        
        if (submenuContent && submenuContent.tagName === 'UL') {
          // サブメニューの内容をspMenuContentsに設定
          spMenuContents.innerHTML = submenuContent.outerHTML;
          
          // タイトル部分の表示を変更
          titleHeading.style.display = 'none';
          backSpMenu.style.display = 'block grid';
          backSpMenu.classList.add('is-show');
          
          // 必要に応じてクラスを追加
          spMenuContents.classList.add('submenu-active');
        }
      });
    });
    
    // 戻るボタンの処理
    backSpMenu.addEventListener('click', () => {
      // 元のメニューコンテンツに戻す
      spMenuContents.innerHTML = originalContents;
      
      // タイトル部分を元に戻す
      titleHeading.style.display = 'block grid';
      backSpMenu.style.display = 'none';
      backSpMenu.classList.remove('is-show');
      
      // クラスを削除
      spMenuContents.classList.remove('submenu-active');
      
      // サブメニューを開く処理を再度バインド
      document.querySelectorAll('.open-submenu').forEach(submenuBtn => {
        submenuBtn.addEventListener('click', function() {
          const submenuContent = this.nextElementSibling;
          if (submenuContent && submenuContent.tagName === 'UL') {
            spMenuContents.innerHTML = submenuContent.outerHTML;
            titleHeading.style.display = 'none';
            backSpMenu.style.display = 'block grid';
            backSpMenu.classList.add('is-show');
            spMenuContents.classList.add('submenu-active');
          }
        });
      });
    });
  }
});

/*-------------------------------------
 SPメニューの開閉処理
--------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  // メニュー開閉処理を関数化
  function setupMenu(openBtnId, closeBtnId, menuId) {
    const openBtn = document.getElementById(openBtnId);
    const closeBtn = document.getElementById(closeBtnId);
    const menu = document.getElementById(menuId);
    
    if (openBtn && closeBtn && menu) {
      openBtn.addEventListener('click', () => {
        menu.classList.add('is-show');
      });
      
      closeBtn.addEventListener('click', () => {
        menu.classList.remove('is-show');
      });
    }
  }

  // 左側メニューと右側メニューの設定を関数で処理
  setupMenu('openSpMenu', 'closeSpMenu', 'spMenu');
  setupMenu('openSpRightMenu', 'closeSpRightMenu', 'spRightMenu');
});

/*-------------------------------------
 PCメニューの開閉処理
--------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {
  
  const gnavCategoriesPCItems = document.querySelectorAll('#gnavCategoriesPC .unit h3');
  
  if (gnavCategoriesPCItems.length) {
    // すべてのアイテムの状態をリセットする関数
    function resetAllItems() {
      gnavCategoriesPCItems.forEach(resetItem => {
        resetItem.classList.remove('is-active');
        const resetSubMenu = resetItem.nextElementSibling;
        if (resetSubMenu && resetSubMenu.classList.contains('child')) {
          resetSubMenu.classList.remove('is-active');
          resetSubMenu.style.height = '0';
        }
      });
    }

    const body = document.body;
    let hadIsDownClass = body.classList.contains('is-down');
    const bodyClassObserver = new MutationObserver(() => {
      const hasIsDownClass = body.classList.contains('is-down');
      if (!hadIsDownClass && hasIsDownClass) {
        resetAllItems();
      }
      hadIsDownClass = hasIsDownClass;
    });
    bodyClassObserver.observe(body, {
      attributes: true,
      attributeFilter: ['class']
    });

    gnavCategoriesPCItems.forEach(item => {
      const subMenu = item.nextElementSibling;
      if (subMenu && subMenu.classList.contains('child')) {
        subMenu.setAttribute('data-height', subMenu.scrollHeight + 'px');
        
        // .closeボタンのクリックイベントを追加
        const closeButton = subMenu.querySelector('.close');
        if (closeButton) {
          closeButton.addEventListener('click', function(e) {
            e.stopPropagation(); // 親要素へのイベント伝播を防ぐ
            resetAllItems();
          });
        }
      }
      
      item.addEventListener('click', function() {
        // クリックされたアイテムが既にアクティブかチェック
        const isCurrentlyActive = this.classList.contains('is-active');
        
        // すべてのアイテムの状態をリセット
        resetAllItems();
        
        // クリックされたアイテムが既にアクティブでない場合のみアクティブにする
        if (!isCurrentlyActive) {
          this.classList.add('is-active');
          const subMenu = this.nextElementSibling;
          if (subMenu && subMenu.classList.contains('child')) {
            subMenu.classList.add('is-active');
            subMenu.style.height = subMenu.getAttribute('data-height');
          }
        }
      });
    });
  }

  const topMainNav = document.getElementById('topMainNav');
  if (topMainNav) {
    topMainNav.querySelectorAll('h4').forEach(heading => {
      const subMenu = heading.nextElementSibling;
      if (!subMenu || !subMenu.classList.contains('sub')) return;

      heading.addEventListener('click', () => {
        heading.classList.toggle('is-active');
        subMenu.classList.toggle('is-active');
      });
    });
  }

  const switchButton = document.getElementById('switchButton');
  if (switchButton) {
    const SWITCH_BUTTON_STORAGE_KEY = 'categoryViewSwitch';
    const inputs = switchButton.querySelectorAll('input[name="switch"]');
    const savedValue = localStorage.getItem(SWITCH_BUTTON_STORAGE_KEY);

    if (savedValue) {
      const savedInput = [...inputs].find(input => input.id === savedValue);
      if (savedInput) {
        savedInput.checked = true;
      }
    }

    inputs.forEach(input => {
      input.addEventListener('change', () => {
        if (input.checked) {
          localStorage.setItem(SWITCH_BUTTON_STORAGE_KEY, input.id);
        }
      });
    });
  }

  initAggressiveSection();
});